export default "__VITE_ASSET__BGAF2Exo__"